module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9d31b6ab445d9d7f66d3e36418d350c4.png";